module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Glossary"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('b', [_vm._v("Glossary")])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_c('i', [_vm._v("Waffen SS")]), _vm._v(" Ranks and British Army Equivalents:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Obersturmbannführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Lieutenant Colonel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Sturmbannführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Major")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Hauptsturmführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Captain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Obersturmführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Lieutenant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Untersturmführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("2nd Lieutenant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Standartenoberjunker")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("(no equivalent)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Hauptscharführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Battalion Sergeant Major")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Oberscharführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Company Sergeant Major")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Scharführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Platoon Sergeant Major")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Unterscharführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Rottenführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Corporal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Sturmmann")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Lance Corporal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Oberschütze")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Private First Class [US rank]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("SS Schütze")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Private")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Other terms:")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Ausbildung")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("training [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Davai")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("‘hurry’ [Russian]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Du meine Fresse")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("‘bloody hell!’ [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Fils de salop")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("‘son of a bitch’ [French]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Heeresgruppe")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Army Group [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Karrotenkopf")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("red-haired person, meaning ‘carrot head’ [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Kriegsmarine")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("navy [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Kübelwagen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("German military vehicle similar to jeep")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("niaqué")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Vietnamese female farm worker")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Matrose")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("naval rating [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Maudit")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("‘goddam or damn it’[French]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Munitionschütze")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("soldier responsible for keeping a field piece supplied with ammunition [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('i', [_vm._v("Ostarbeiter")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("a worker from the east – often Russian [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Panzerfaust (pl.Panzerfäuste)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("a rocket-propelled anti-tank weapon [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Pioniere")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("field engineers [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Porco boia")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Italian expletive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Prévôtè")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Provost [French]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("rez-de-chaussée")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("the ground floor storey of a building [French]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Richtschütze")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("gun-layer [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("roulante")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("mobile field kitchen [French]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Scheisse")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("‘shit’ [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Soldbuch (pl. Soldbücher)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("German soldier’s identity and pay book")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Sommelier")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("trained wine steward in an expensive restaurant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Sigrun")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("the angular double ‘S’ symbol used by the "), _c('i', [_vm._v("SS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Standartenoberjunker")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("most senior rank of an "), _c('i', [_vm._v("SS")]), _vm._v(" officer candidate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("tholang")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Vietnamese head of a village")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("tirailleur")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Senegalese rifleman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Truppführer")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("troop leader [German]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Volkssturm")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("German reserve force composed of male civilians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('i', [_vm._v("Zeltbahn (pl. Zeltbahen)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("waterproof tent quarter carried by German soldiers")])])])])])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb17fed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Glossary.vue
// module id = 81
// module chunks = 0